import {configureStore} from '@reduxjs/toolkit'
import loginreducer from './LoginSlice'
import CandidateReducer from './CandidateSlice'
import StaffReducer from './StaffSlice'
import BulkaddReducer from './BulkaddSlice'
import NotificationReducer from './NotificationSlice'
import CountReducer from './CountSlice'
import ChatReducer from './ChatSlice'
import RemarkReducer from './RemarkSlice'
import DashboardReducer from './DashboardSlice'
import ResumeReducer from '../pages/layouts/resume/ResumeSlice'
import ManagementReducer from '../pages/layouts/management/ManagementSlice'
import DashboardResumeReducer from '../pages/layouts/dashboard/DashboardSlice'
import HRMSReducer from '../pages/layouts/hrms/hrmsSlice'
import HolidayReducer from '../pages/layouts/hrms/company/HolidaySlice'
import JotReducer from "../pages/layouts/jot/JotSlice"
import AdmissionReducer from "../pages/layouts/Admission/admissionSlice"
import JapaneseAdmissionReducer from "../pages/layouts/japaneseAdmission/japaneseAdmissionSlice"
import IsraelReducer from './IsrealSlice';
import keralaAdmissionSlice from '../pages/layouts/resume/kerala/keralaAdmissionSLice';

export const store = configureStore({
    reducer:{
        Login:loginreducer,
        Candidate:CandidateReducer,
        Staffdata:StaffReducer,
        Bulkadd:BulkaddReducer,
        Notification:NotificationReducer,
        Count:CountReducer,
        Chat:ChatReducer,
        Remark:RemarkReducer,
        Dashboard:DashboardReducer,
        Israel:IsraelReducer,
        Resume: ResumeReducer,
        DashboardResume:DashboardResumeReducer,
        hrms:HRMSReducer,
        holiday:HolidayReducer,
        jot: JotReducer,
        admission: AdmissionReducer,
        japaneseAdmission: JapaneseAdmissionReducer,
        management: ManagementReducer,
        keralaAdmission:keralaAdmissionSlice

    }

})